import { invoiceKeyStore } from 'Store/keyStore'
import { ICreateCustomerRequest, IProduct, ISelectedItem, ProductViewModel, InvoiceStatusType, InvoiceActionType  } from "Models";

export interface IInvoiceProduct {
    products: Array<IProduct>,
    originalProducts?: Array<ProductViewModel>,
    productSelected?: ProductOptionSelected
}

export interface ProductOptionSelected {
    product: IProduct,
    index: number
}

export interface IInvoiceState {
    id?: string;
    invoiceNumber?: string;
    adjustId?: string;
    replaceById?: string;
    invoiceType?: InvoiceActionType,
    invoiceStatusType?: InvoiceStatusType,
    invoiceTaxNumber?: string | undefined,
    serialTT32?: ISelectedItem;
    createDate?: string;
    customerSelected?: ICreateCustomerRequest,
    paymentSelected?: ISelectedItem,
    currencyTypeSelected?: ISelectedItem,
    product?: IInvoiceProduct
}

interface State {
    productAction: {},
    copyInvoiceToggle: boolean,
    invoice: {}
}

const getters = {
    [invoiceKeyStore.COPY_INVOICE_TOGGLE]: (state: State) => {
        return state.copyInvoiceToggle || false;
    },
    [invoiceKeyStore.INVOICE]: (state: State) => {
        return state.invoice as IInvoiceState;
    },
    [invoiceKeyStore.INVOICE_PRODUCT_OPTION_SELECTED]: (state: State) => {
        const action = state.productAction;
        state.productAction = {};
        return action;
    }
}

const mutations = {
    [invoiceKeyStore.INVOICE]: (state: State, val: IInvoiceState) => {
        state.invoice = val;
    },
    [invoiceKeyStore.INVOICE_PRODUCT_OPTION_SELECTED]: (state: State, val: any) => {
        state.productAction = val ?? {};
    },
    [invoiceKeyStore.COPY_INVOICE_TOGGLE]: (state: State, val: boolean) => {
        state.copyInvoiceToggle = val as boolean;
    }
}

const actions = {

}


export default {
    mutations: mutations,
    actions: actions,
    getters: getters
};

